import { DirectoryItem } from "../directory/Directory"

export interface ConceptValueRange {
	rangeLow: number|null
	normalLow: number|null
	normalHigh: number|null
	rangeHigh: number|null
}

export const newConceptValueRangeFromString = (s: string|null): ConceptValueRange|null => {
	if(!s) {
		return null
	}
	const parts = s.split(',')
	if(parts.length !== 4) {
		// TODO this should display on the flowmap
		return null
	}
	return {
		rangeLow: (parts[0].trim() !== '') ? Number(parts[0]) : null,
		normalLow: (parts[1].trim() !== '') ? Number(parts[1]) : null,
		normalHigh: (parts[2].trim() !== '') ? Number(parts[2]) : null,
		rangeHigh: (parts[3].trim() !== '') ? Number(parts[3]) : null,
	}
}

export const xfValueRangeFromDirItem = (dirItem: DirectoryItem) => [
	dirItem.Range_Low,
	dirItem.Normal_Low,
	dirItem.Normal_High,
	dirItem.Range_High,
].join(',')
